export default {
  state: {
    id: undefined,
    subscriber_id: undefined,
    newsletter_type_id: undefined,
    newsletter_type: {
    },
    subscriber_email: undefined,
    subscription_token: undefined,
    subscription_state: undefined,
    subscription_user: {
      id: undefined,
      name: undefined,
      username: undefined
    },
    bounced_at: undefined,
    pending_at: undefined,
    accepted_at: undefined,
    status: undefined,
    unsubscribed_at: undefined,
    verified: true,
    relationships: {},
    created_at: undefined,
    updated_at: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/NewsletterTypeSubscriberStore.js